import { Card } from './ui/card';
import { DollarSign, AlertTriangle, TrendingUp, Zap, Clock, Target } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
  {
    icon: DollarSign,
    title: 'Custos Reais',
    description: 'Cálculo preciso baseado na FIPE atualizada com dados de mercado em tempo real.',
  },
  {
    icon: AlertTriangle,
    title: 'Análise de Danos',
    description: 'Estimativa de custos de reparos para decisões mais informadas (em breve).',
  },
  {
    icon: TrendingUp,
    title: 'Margem de Lucro',
    description: 'Projeção de ROI considerando custos de reparo e valor de revenda.',
  },
  {
    icon: Zap,
    title: 'IA Preditiva',
    description: 'Algoritmos avançados para prever tendências de valorização (em breve).',
  },
  {
    icon: Clock,
    title: 'Resultado Instantâneo',
    description: 'Análise completa em segundos, direto no seu navegador.',
  },
  {
    icon: Target,
    title: 'ROI Garantido',
    description: 'Recomendações que maximizam seu retorno sobre investimento.',
  },
];

export function Features() {
  return (
    <section className="py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-4">
            Diferenciais
          </h2>
          <p className="text-lg text-muted-foreground">
            Ferramentas profissionais para comprar com inteligência e segurança
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="group p-6 h-full bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/30 hover:shadow-xl hover:shadow-primary/5 transition-all duration-300 hover:-translate-y-1">
                <div className="space-y-4">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                    <feature.icon className="w-7 h-7 text-primary group-hover:text-primary-foreground transition-colors" />
                  </div>
                  
                  <h3 className="text-xl font-heading font-semibold">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
